var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitorsMapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.929149 0C0.415052 0 0 0.431126 0 0.965346V14.0347C0 14.5689 0.415052 15 0.929149 15H10.0709C10.5849 15 11 14.5689 11 14.0347V0.965346C11 0.431094 10.5849 0 10.0709 0H0.929149ZM4.26479 1.78573H6.70326C6.8849 1.78299 7.05239 1.95414 7.05239 2.14284C7.05239 2.33155 6.8849 2.5027 6.70326 2.49996H4.29705C4.11697 2.5088 3.94565 2.34662 3.93712 2.15952C3.92872 1.97255 4.08482 1.79443 4.26479 1.7857V1.78573ZM5.50015 5.35719C6.3545 5.35719 7.04698 6.07665 7.04698 6.96428C7.04698 7.85192 6.3545 8.5715 5.50015 8.5715C4.6458 8.5715 3.95332 7.85192 3.95332 6.96428C3.95332 6.07665 4.6458 5.35719 5.50015 5.35719ZM5.50015 10.0001C7.59503 10.0001 8.93769 11.0748 8.93769 12.3216V12.8573H2.06262V12.3216C2.06262 11.0748 3.40528 10.0001 5.50015 10.0001Z",
    fill: "url(#paint0_linear_974_4751)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_4751",
    x1: 0,
    y1: 7.5,
    x2: 11,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorsMapping);
export default __webpack_public_path__ + "static/media/visitorsMapping.468947d5e5502d36e8ab43bc3fc164c4.svg";
export { ForwardRef as ReactComponent };